import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { Tab } from "../../../../Tab";
import { Tabs } from "../../../../Tabs";
import { tabs } from "../../utils/data";
import { jsx as _jsx } from "react/jsx-runtime";
export var FilterTabs = function FilterTabs() {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var onTabChange = function onTabChange(value) {
    setSelectedTab(value);
  };
  return /*#__PURE__*/_jsx(Tabs, {
    value: selectedTab,
    onTabChange: onTabChange,
    className: "tw-flex tw-justify-start tw-bg-transparent dark:tw-bg-transparent tw-mt-1.6",
    children: tabs.map(function (_ref) {
      var key = _ref.key,
        label = _ref.label;
      return /*#__PURE__*/_jsx(Tab, {
        label: label,
        size: "s"
      }, key);
    })
  });
};